module.exports = __webpack_public_path__ + "img/arrow-down-white.0c06c551.svg";